import { Component, h, Listen, State, Host } from '@stencil/core';
import { MESSAGES } from '../constants';

@Component({
  tag: 'app-update-message',
  shadow: false,
})
export class AppUpdateMessage {

  @State()
  private showUpdateIsAvailable = false;

  public render() {
    return (<Host>
      {this.showUpdateIsAvailable && <div class='update-modal'>
        <div class='update-modal__overlay'></div>
        <div class='update-modal__window'>
          <div class="update-modal__icon">
            <belimo-svg-sprite svgId={'update'}/>
          </div>
          <div class="update-modal__text">
            <h3>
              <belimo-i18n messageId={MESSAGES.NEW_VERSION_AVAILABLE}/>
            </h3>
            <p>
              <belimo-i18n messageId={MESSAGES.RELOAD_NOW}/>
            </p>
          </div>
        </div>
      </div>}
    </Host>);
  }

  @Listen("swUpdate", { target: 'window' })
  async onServiceWorkerUpdate() {
    const registration = await navigator.serviceWorker.getRegistration();

    if (!registration?.waiting) {
      return;
    }

    try {
      registration.waiting.postMessage("skipWaiting");
      console.log('skip waiting');
    } catch (e) {
      console.warn(e);
    }

    this.showUpdateIsAvailable = true;
  }
}
